export const UNNAMED_CONTACT_LABEL = 'Unnamed contact';

/** Select option value representing "no contact", since Radix Select forbids empty string values. */
export const NO_CONTACT_VALUE = 'none';

/** Name parts are optional because no contact field is mandatory. */
export interface ContactNameParts {
  title?: string | null;
  firstName?: string | null;
  surname?: string | null;
  email?: string | null;
  phone?: string | null;
}

/** Falls back to email, then phone, then a placeholder so a nameless contact is never rendered blank. */
export function contactDisplayName(contact: ContactNameParts | null | undefined): string {
  if (!contact) return UNNAMED_CONTACT_LABEL;

  const name = [contact.title, contact.firstName, contact.surname]
    .map((x) => x?.trim() ?? '')
    .filter((x) => x !== '')
    .join(' ');

  return name || contact.email?.trim() || contact.phone?.trim() || UNNAMED_CONTACT_LABEL;
}
